import styled, { css } from "styled-components";
import { ITheme } from "../../styles/theme";
import { Button } from "antd";

export const MenuWrapper = styled.div`
  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
  }
`;

export const MenuContainer = styled.div<{
  isOpen: boolean;
  isSimple: boolean;
  menuColor: string;
}>`
  width: 500px;
  height: 100vh;
  overflow: hidden auto;
  border-right: solid 1.5px ${(props) => props.theme.colors.borderGray};

  background-color: ${(props) =>
    props.menuColor ? props.menuColor : props.theme.colors.backgroundGray};

  box-sizing: border-box;
  padding: 30px 80px;

  display: flex;
  flex-direction: column;
  justify-content: inherit;

  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: ${(props) =>
      props.theme.mediaQueryConstants.desktopSmall}px) {
    width: 400px;
    padding: 40px;
  }

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    width: 100%;
    height: ${(props) =>
      props.isSimple ? (props.isOpen ? "350px" : "0") : "auto"};
    padding: 25px 15px;
    transition: height 0.4s ease;
    z-index: 12;
    position: ${(props) => (props.isSimple ? "relative" : "unset")};
  }

  @media (max-width: ${(props) =>
      props.theme.mediaQueryConstants.veryLowHeight}px) {
    height: ${(props) =>
      props.isSimple ? (props.isOpen ? "250px" : "0") : "auto"};
  }
`;

export const FooterContainer = styled.div<{
  isOpen: boolean;
  isSimple: boolean;
  isPlugin: boolean;
  menuSide: string;
  menuColor: string;
}>`
  position: fixed;
  ${(props) =>
    props.menuSide == "right"
      ? css`
          left: 50px;
        `
      : css`
          right: 50px;
        `}
  bottom: 40px;
  width: ${(props) =>
    props.isPlugin ? "auto" : "calc(100vw - 500px - 50px - 65px)"};
  z-index: 9;
  height: 60px;
  background-color: ${(props) =>
    props.menuColor ? props.menuColor : props.theme.colors.backgroundGray};
  display: flex;
  align-items: center;
  border: solid 1.5px ${(props) => props.theme.colors.borderGray};

  @media (max-width: ${(props) =>
      props.theme.mediaQueryConstants.desktopSmall}px) {
    width: calc(100vw - 400px - 30px - 40px);
    ${(props) =>
      props.menuSide == "right"
        ? css`
            left: 30px;
          `
        : css`
            right: 30px;
          `}
    flex-direction: column;
    align-items: flex-start;
    height: 70px;
    padding: 15px 25px;
  }

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    position: ${(props) => (props.isSimple ? "relative" : "unset")};
    z-index: 14;
    width: 100%;
    ${(props) =>
      props.menuSide == "right"
        ? css`
            left: 0;
          `
        : css`
            right: 0;
          `}
    bottom: 0;
    padding: 15px 20px 15px 15px;
    top: ${(props) => (props.isOpen ? "0" : "50px")};
    height: ${(props) => (props.isSimple ? "70px" : "auto")};
  }
`;

export const NotifyWrapper = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  z-index: 9;
  color: ${(props) => props.theme.colors.red};
  background: rgba(255, 0, 0, 0.2);
  padding: 5px 10px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    top:-50px;   
  }
`;

export const PriceWrapper = styled.div<{ isPlugin: boolean }>`
  padding-left: 55px;
  display: flex;
  height: 100%;
  align-items: center;
  padding-right: 50px;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: ${(props) => (props.isPlugin ? "0" : "1.5px")};
    height: 100%;
    background: ${(props) => props.theme.colors.borderGray};
    position: absolute;
    right: 0;
  }

  @media (max-width: ${(props) =>
      props.theme.mediaQueryConstants.desktopSmall}px) {
    height: auto;
    width: 100%;
    justify-content: space-between;
    padding-left: 0;
    padding-right: 0;
    &::before {
      display: none;
    }
  }
`;

export const TotalPrice = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-right: 35px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    font-size: 16px;
    margin-right: 20px;
  }
`;

export const ButtonWithBackground = styled(Button)<{ isPlugin: boolean }>`
  width: ${(props) => (props.isPlugin ? "auto" : "133px")};
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 25px;
  padding: 10px 20px;
  background: ${(props) => props.theme.colors.buttonBlack};
  border-color: ${(props) => props.theme.colors.buttonBlack};
  color: ${(props) => props.theme.colors.white};
  transition: all 0.6s ease;
  &:hover,
  &:focus {
    background: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.buttonBlack};
    color: ${(props) => props.theme.colors.buttonBlack};
    box-shadow: none;
  }
  & .text {
    font-size: 11px;
  }

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    width: auto;
    padding: 10px 15px;
    & .anticon {
      font-size: 10px;
      line-height: 8px;
    }
    & .text {
      margin-right: 7px;
    }
  }
`;

export const FooterDetail = styled.div`
  padding-left: 60px;
  padding-right: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;

  @media (max-width: ${(props) =>
      props.theme.mediaQueryConstants.desktopSmall}px) {
    height: auto;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FooterDetailText = styled.div<{ fontSize?: string }>`
  color: ${(props) => props.theme.colors.textGray};
  font-weight: 500;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "12px")};

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    font-size: ${(props) => (props.fontSize ? "12px" : "11px")};
  }
`;

export const FooterOpenBtn = styled.div`
  padding:7px 10px;  
  position: absolute;
  bottom: 100%;
  right: -1px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.backgroundGray};
  border: solid 1.5px ${(props) => props.theme.colors.borderGray};
  border-bottom: none;
  border-radius: 10px 10px 0px 0px;
  font-size: 12px;
  color: ${(props) => props.theme.colors.textGray};
  & svg{
    width:15px;
    height:15px;   
  }
  & svg path{
    stroke:${(props) => props.theme.colors.textGray};
  }
`;
